import { usePublicBoundlessConfigRetrieveSuspense } from "@boundless/bl-api-client/public/services"

import { cn } from "@/lib/utils"

export function FormConsentText({
  action,
  className,
}: {
  action: string
  className?: string
}) {
  const { data: config } = usePublicBoundlessConfigRetrieveSuspense()

  return (
    <p className={cn("text-muted text-center text-xs text-balance", className)}>
      By {action}, you warrant that you have fully read and understood, and
      acknowledge and agree to, Boundless Financial Corp.&apos;s{" "}
      <a
        className="text-muted underline"
        href={config.termsOfServiceUrl}
        target="_blank"
        rel="noreferrer"
      >
        Terms of Service
      </a>{" "}
      and{" "}
      <a
        className="text-muted underline"
        href={config.privacyPolicyUrl}
        target="_blank"
        rel="noreferrer"
      >
        Privacy Policy
      </a>
      .
    </p>
  )
}
